/**
 * curated-types — F12.D T12.D.9.
 *
 * Lista 15 typów pól pokazywanych w prostym dropdownie „Dodaj pole" w Ustawieniach.
 * Pełne 48 typów jest zarejestrowane w `FieldRegistry` (z F12.B) — ale tutaj
 * curated subset zgodny z UI SellCall (Ustawienia → Pola modułów → Dodaj nowe pole).
 *
 * Pozostałe 33 typy (signature, qrcode, formula, lookup, rollup, richtext...) są
 * dostępne w buildery formularzy / pod toggle „Pokaż zaawansowane" (deferred).
 *
 * @see docs/phases/PHASE_12D_PLAN.md §T12.D.9 — decyzja produktowa
 */
export const CURATED_FIELD_TYPES = [
  'text',
  'textarea',
  'number',
  'date',
  'datetime',
  'select',
  'multiselect',
  'checkbox',
  'email',
  'phone',
  'url',
  'currency',
  'file',
  'relation',
  'user',
] as const;

export type CuratedFieldType = (typeof CURATED_FIELD_TYPES)[number];

/** Klucz i18n dla labelki typu pola: `tenant.fieldTypes.<type>` */
export function fieldTypeI18nKey(type: string): string {
  return `tenant.fieldTypes.${type}`;
}
